<template>
  <v-expansion-panel class="accordion-services">
    <v-expansion-panel-header class="accordion-services__header">
      {{group.name}}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-expansion-panels v-if="group.children">
        <template v-for="child in makeGroupedServiceList(group.children)">
          <accordion-services-group
            v-if="checkGroupHasServices(child)"
            v-bind:key="child.id"
            v-bind:group="child"
            v-bind:selected-services-ids="selectedServicesIds"
            v-on:select-service="onSelectService"
          />
        </template>
      </v-expansion-panels>
      <div class="accordion-services__items">
        <span
          v-for="item in group.services"
          v-bind:key="item.id"
          class="accordion-services__item"
          :class="{ selected: isSelected(item) }"
        >
          <p>{{item.clinic_code}}</p>
          <button class="accordion-services__item__button" type="button" v-on:click="onSelectService(item)">
            <span>{{ item.name }}</span>
          </button>
          <the-rub
            currency="тнг"
            v-bind:show-kop="$options.SHOW_KOP_AUTO"
            v-bind:kop="item.cost" />
        </span>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';

/**
 * @description Группа услуг для аккордеона.
 * @type {Vue}
 */
export default {
  SHOW_KOP_AUTO,
  components: {
    TheRub,
  },
  methods: {
    /**
     * @description Обработать выбор услуги.
     * @param {Object} service     Услуга.
     * @returns {void}
     */
    onSelectService(service) {
      this.$emit('select-service', service);
    },
    /**
     * @description Изменить цвет выбранной услуги на синий.
     * @param {Object} evt     Событие.
     * @returns {void}
     */
    onSelectSetColor(evt) {
      const currentService = evt.target;
      if (currentService.parentNode.parentNode.classList.contains('selected')) {
        currentService.parentNode.parentNode.classList.remove('selected');
      } else {
        currentService.parentNode.parentNode.classList.add('selected');
      }
      if (currentService.classList.contains('selected')) {
        currentService.classList.remove('selected');
      } else {
        currentService.classList.add('selected');
      }
    },
    /**
     * @description Создать список сгруппированных услуг.
     * @param {Object[]} children
     * @returns {Object[]}
     */
    makeGroupedServiceList(children) {
      return children.map((group) => ({
        id: group.id,
        name: group.name,
        services: group.services,
        children: group.children,
        hasStages: group.stages?.length > 0,
        stages: group.stages?.map((stage) => ({
          id: stage.id,
          name: stage.name,
          services: stage.services,
        })),
      }));
    },
    /**
     * @description Проверить категорию на наличие услсуг.
     * @param {Object} group Сгруппированая категория услуг.
     * @returns {boolean}
     */
    checkGroupHasServices(group) {
      return !!group.services.length;
    },
    /**
     * @description Является ли услуга выбранной.
     * @type {Object}  service Услуга.
     * @returns {boolean}
     */
    isSelected(service) {
      return this.selectedServicesIds.includes(service.serviceId ?? service.id);
    },
  },
  name: 'AccordionServicesGroup',
  props: {
    /**
     * @description Список сгруппированных услуг.
     * @type {id:number,name:string,services:Object[]}
     */
    group: { required: true, type: Object },
    /**
     * @description Список выбранных услуг.
     * @type {any[]}
     */
    selectedServicesIds: { default: () => [], type: Array },
  },
};
</script>

<style scoped lang="scss">
.accordion-services {
  &__header {
    display: flex;
    align-items: center;
    padding-block: 14px;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 10px;
    list-style: none;
    padding-left: 20px !important;
  }
  &__item {
    display: grid;
    grid-template-columns: 145px 1fr auto;
    grid-gap: 5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    &__button {
      max-width: 400px;
      text-align: left;
      transition: color 0.2s;
      &:active {
        color: #029bff;
      }
    }
    &.selected {
      color: #029bff;
      font-weight: 600;
    }
    @media (hover: hover) {
      &:hover {
        color: #029bff;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .accordion-services {
    &__item {
      grid-template-columns: 1fr;
      border-bottom: 1px solid #90a0b7;
      padding: 0 0 10px 0;
      &:last-child {
        border-bottom: none;
      }
      &.selected {
        background: #eaeff3;
      }
    }
  }
}
</style>
